module.exports = __webpack_public_path__ + "img/lo.e302f942.png";